import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { easeMove } from '../../utils/motion';
type MatchVisualProps = {
  active: number;
};
const candidates = [{
  name: 'Summer city series',
  fit: 92
}, {
  name: 'Weekend wellness fair',
  fit: 74
}, {
  name: 'Campus discovery day',
  fit: 58
}];

/**
 * The Sponsor AI match panel. As the section passes, a brief becomes a ranked
 * shortlist and the strongest candidate is selected.
 */
export function MatchVisual({
  active
}: MatchVisualProps) {
  const reduceMotion = useReducedMotion();
  const listed = active >= 1;
  const scored = active >= 2;
  const selected = active >= 3;
  const transition = {
    duration: 0.3,
    ease: easeMove
  };
  return <div className="mx-auto w-full max-w-md" data-id="element-692" data-mp="32t1hkeqvgwzw">
      <div className="border border-ink/20 bg-paper p-5" data-id="element-693" data-mp="1chya542r4lsg">
        <div className="flex items-center justify-between border-b border-ink/15 pb-4" data-id="element-694" data-mp="1ckjfi329djuy">
          <p className="text-sm font-extrabold text-ink" data-id="element-695" data-mp="18j7mdnk6egi0">Candidate contexts</p>
          <span className="bg-iris px-2 py-1 text-[10px] font-extrabold tracking-[0.1em] text-paper" data-id="element-696" data-mp="349sldoudlz2m">
            {scored ? 'RANKED' : 'MATCHING'}
          </span>
        </div>

        <ul className="mt-4 flex flex-col gap-3" data-id="element-697" data-mp="3e642cs4wvd3e">
          {candidates.map((candidate, index) => {
          const isTop = index === 0;
          return <motion.li key={candidate.name} animate={{
            opacity: listed ? 1 : 0.3
          }} transition={transition} className={`border p-3 ${selected && isTop ? 'border-iris bg-iris/5' : 'border-ink/15 bg-white'}`} data-id="element-698" data-mp="3nw70t7usxj94" data-mpi={index}>
                <div className="flex items-center justify-between gap-3" data-id="element-699" data-mp="22iu9cyu53ycy">
                  <span className="text-sm font-semibold text-ink" data-id="element-700" data-mp="22kylu563u5ou">
                    {candidate.name}
                  </span>
                  <span className="shrink-0 text-xs font-extrabold text-iris" data-id="element-701" data-mp="1zgzgygpro5db">
                    {scored ? `${candidate.fit}% fit` : '—'}
                  </span>
                </div>
                <div className="mt-3 h-1.5 bg-ink/10" data-id="element-702" data-mp="29ff9mo4fzmox">
                  <motion.div animate={{
                width: reduceMotion ? `${candidate.fit}%` : scored ? `${candidate.fit}%` : '0%'
              }} transition={transition} className="h-full bg-iris" data-id="element-703" data-mp="29g87ezlfb1ux" />
                </div>
                {selected && isTop && <p className="mt-3 text-xs font-extrabold text-iris" data-id="element-704" data-mp="2n73h2e3qxmzk">
                    SELECTED — TAKE INTO A CAMPAIGN
                  </p>}
              </motion.li>;
        })}
        </ul>
      </div>
      <p className="mt-5 text-center text-xs font-bold text-ink/55" data-id="element-705" data-mp="2x6av73ib1lnq">
        ILLUSTRATIVE MATCHING INTERFACE — NOT MODEL OUTPUT
      </p>
    </div>;
}